module.exports = __webpack_public_path__ + "img/SortByDate.8026547d.svg";